import React from "react";
import Navigation from "./Navigation";
import { NavLink } from "react-router-dom";

const Sidebar = () => (
  <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 bg-white shadow-lg z-50">
    <NavLink className="m-auto md:w-56 py-7" to="/">
      <img className="max-h-10 w-auto" src="/hotelworld-logo.svg" alt="logo" />
    </NavLink>
    <div className="flex flex-col flex-grow overflow-y-auto">
      <div className="mt-8 flex-1 flex flex-col">
        <nav className="flex-1 px-4 pb-4">
          <Navigation />
        </nav>
      </div>
    </div>
  </div>
);

export default Sidebar;
